import { render, staticRenderFns } from "./featuresDelete.vue?vue&type=template&id=66104620&"
import script from "./featuresDelete.vue?vue&type=script&lang=js&"
export * from "./featuresDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports